import * as checkoutActions from "./checkout.actions";
import * as checkoutSetupActions from "./setup/index";
import { Action, createReducer, on } from "@ngrx/store";
import { CheckoutState } from "..";
import { CHECKOUT_STEPS_NAMES } from "app/shared/name/name.library";
import { continueButton } from "../helpers/checkout/continue-button";

const initialState: CheckoutState = {
	steps: {
		aboutYou: null,
		setup: null,
		paymentDetails: null,
		terms: null,
		proofOfId: null,
		selectedPaymentMethod: null
	},
	continue: {
		busy: false,
		enabled: false,
		text: "CONTINUE",
	},
	currentStep: CHECKOUT_STEPS_NAMES?.aboutYou,
	info: null,
	customerData: null,
};

const featureReducer = createReducer(
	null,
	on(checkoutActions.initiateCheckoutState, () => initialState),
	on(checkoutActions.initiateAuthenticatedOrderState, (state) => {
		return {
			...state,
			continue: {
				busy: false,
				enabled: true,
				text: "CONTINUE",
			},
			currentStep: CHECKOUT_STEPS_NAMES?.aboutYou,
		};
	}),
	on(checkoutActions.resetCheckoutState, () => {
		return null;
	}),
	on(checkoutActions.setCurrentStepCheckout, (state, { currentStep }) => {
		return {
			...state,
			currentStep,
		};
	}),
	on(checkoutActions.setAboutYou, (state, { aboutYou }) => {
		const continueBtn = continueButton(
			aboutYou?.valid,
			CHECKOUT_STEPS_NAMES.aboutYou
		);
		return {
			...state,
			steps: {
				...state.steps,
				aboutYou,
			},
			continue: continueBtn,
		};
	}),
	on(checkoutActions.setProofOfId, (state, { proofOfId }) => {
		return {
			...state,
			steps: {
				...state.steps,
				proofOfId,
			},
		};
	}),
	on(
		checkoutSetupActions.setCheckoutSetupMobile,
		(state, { setupData, valid }) => {
			const continueBtn = continueButton(
				valid,
				CHECKOUT_STEPS_NAMES.setup
			);
			return {
				...state,
				steps: {
					...state.steps,
					setup: {
						...state.steps.setup,
						mobile: { ...setupData, valid },
					},
				},
				continue: continueBtn,
			};
		}
	),
	on(
		checkoutSetupActions.setCheckoutSetupMobileContinue,
		(state, { valid }) => {
			const continueBtn = continueButton(
				valid,
				CHECKOUT_STEPS_NAMES.setup
			);
			return {
				...state,
				steps: {
					...state.steps,
					setup: {
						...state.steps.setup,
						mobile: {
							...state.steps.setup.mobile,
							valid,
						},
					},
				},
				continue: continueBtn,
			};
		}
	),
	on(checkoutActions.resetPaymentDetails, (state) => {
		return {
			...state,
			steps: {
				...state.steps,
				paymentDetails: null,
			},
		};
	}),
	on(checkoutActions.setPaymentDetails, (state, { paymentDetails }) => {
		const termsAccepted = !!state?.steps?.paymentDetails?.termsAccepted;
		const continueBtn = continueButton(
			paymentDetails?.paymentFormValid && termsAccepted,
			CHECKOUT_STEPS_NAMES.paymentDetails
		);
		return {
			...state,
			steps: {
				...state.steps,
				paymentDetails: {
					...state.steps.paymentDetails,
					...paymentDetails,
					termsAccepted,
					valid: continueBtn.enabled,
				},
			},
			continue: continueBtn,
		};
	}),
	on(checkoutActions.setIframe, (state, { iframe }) => {
		return {
			...state,
			steps: {
				...state.steps,
				paymentDetails: {
					...state.steps.paymentDetails,
					iframe,
				},
			},
		};
	}),
	on(checkoutActions.setContinueBtnState, (state, { enabled, busy, text }) => {
		return {
			...state,
			continue: {
				...state.continue,
				busy,
				enabled,
				...(text ? { text } : {}),
			},
		};
	}),
	on(checkoutActions.setCheckoutTerms, (state, { terms }) => {
		return {
			...state,
			steps: {
				...state.steps,
				terms,
			},
		};
	}),
	on(checkoutActions.setTermsAccepted, (state, { termsAccepted }) => {
		const continueBtn = continueButton(
			(state?.steps?.paymentDetails?.paymentFormValid || state?.steps?.selectedPaymentMethod) && termsAccepted,
			CHECKOUT_STEPS_NAMES.paymentDetails
		);
		// const continueBtn = continueButton(state?.steps?.paymentDetails?.valid && termsAccepted, CHECKOUT_STEPS_NAMES.paymentDetails);
		return {
			...state,
			steps: {
				...state.steps,
				paymentDetails: {
					...state.steps.paymentDetails,
					termsAccepted,
					valid: continueBtn.enabled,
				},
			},
			continue: continueBtn,
		};
	}),
		on(checkoutActions.setSelectedPayment, (state, selectedPaymentMethod) => {
		// const continueBtn = continueButton(state?.steps?.paymentDetails?.valid && termsAccepted, CHECKOUT_STEPS_NAMES.paymentDetails);
		return {
			...state,
			steps: {
				...state.steps,
				selectedPaymentMethod: selectedPaymentMethod
			},
		};
	}),
	on(checkoutActions.setLead, (state, { lead }) => {
		return {
			...state,
			info: {
				...state?.info,
				lead,
			},
		};
	}),
	on(
		checkoutActions.setPortinExternalId,
		(state, { externalId, attemptsLeft }) => {
			return {
				...state,
				info: {
					...state.info,
					portin: {
						...state?.info?.portin,
						externalId,
						attemptsLeft,
					},
				},
			};
		}
	),
	on(checkoutActions.setContinueBtnBusy, (state, { busy }) => {
		return {
			...state,
			continue: {
				...state.continue,
				busy,
			},
		};
	}),
	on(checkoutActions.setCustomerData, (state, { customerData }) => {
		return {
			...state,
			customerData,
		};
	}),
);

export function checkoutReducer(
	state: CheckoutState | undefined,
	action: Action
): CheckoutState | undefined {
	return featureReducer(state, action);
}
